module.exports = __webpack_public_path__ + "1792395595471/images/africa.7bf519d.png";